export default __webpack_public_path__ + "8b5506f1671a508b978243fad149dddb.svg";